<script setup>
import { useRoute, useRouter } from "vue-router";
import ComHeader from "./components/ComHeader.vue";
import ComFooter from "./components/ComFooter.vue";
import { onMounted, nextTick, reactive, computed } from "vue";
import { useStore } from "vuex";
import axios from "@/plugins/axios.js";

if (location.origin.includes("life-admin.carrotapply.com") || location.origin.includes("stage-lifeedu-admin.carrotenglish.net")) {
} else {
  import("@/assets/css/reset.css");
  import("@/assets/css/tailwind.css");
  import("@/assets/css/ckeditor5-content.css");
}

const router = useRouter();
const route = useRoute();
const store = useStore();

// idx 없이 진입한 예외 페이지에서 상단 헤더만 숨김 (main.js 에서 플래그 세팅)
const hideHeader = computed(() => store.state.hideHeader);

const isNav = computed(() => {
  const isReturnPath =
    route.path !== "/home" &&
    route.path !== "/login/login" &&
    route.path !== "/myClass" &&
    route.path !== "/myPage" &&
    route.path !== "/signUp/signUp0" &&
    route.path !== "/signup/signUp1" &&
    route.path !== "/signUp/signUp1" &&
    route.path !== "/signup/signUp2" &&
    route.path !== "/signUp/signUp2" &&
    route.path !== "/signup/signUp3" &&
    route.path !== "/signUp/signUp3" &&
    route.path !== "/selfLearning";
  return isReturnPath;
});

// 가로 360미만 뷰 고정
const setViewport = () => {
  const viewport = document.getElementById("viewport");
  if (screen.width < 360) {
    viewport.setAttribute("content", "width=360, maximum-scale=1, user-scalable=no");
  } else {
    viewport.setAttribute(
      "content",
      "width=device-width, user-scalable=no, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1"
    );
  }
};

const signUser = reactive({
  homeMainInfoDetail: {
    idxLeSiteMain: "",
    pageNum: 1,
    pageSize: 50,
    homeMainDetailList: [],
    homeMainNoticeList: [],
    idxCompany: "",
    isAdult: "",
    popupImg1: "",
    popupImg2: "",
    popupImg3: "",
    popupImg4: "",
    popupImg5: "",
  },

  getSiteMain() {
    const params = {
      idxLeSiteMain: signUser.homeMainInfoDetail.idxLeSiteMain,
    };

    // 다른 사이트에서 저장된(persist) 값이 실패 시 남지 않게 먼저 비운다
    store.commit("setIdxStaff", 0);
    axios.get(`/user/page/siteMain`, { params }).then(function (res) {
      if (res.data.success === true) {
        signUser.homeMainInfoDetail.homeMainDetailList = res.data.data;
        const companyLogo = signUser.homeMainInfoDetail.homeMainDetailList.companyLogo;
        signUser.homeMainInfoDetail.idxCompany = res.data.data.idxCompany;
        signUser.homeMainInfoDetail.isAdult = res.data.data.isAdult;
        store.commit("setIsQuestion", res.data.data.isQuestion);
        store.commit("setIdxStaff", res.data.data.idxStaff);
        store.dispatch("setCompanyLogo", companyLogo);
        store.commit("setIdxCompany", res.data.data.idxCompany);
        store.commit("setIsCancleFunction", res.data.data.isCancleFunction);
        signUser.homeMainInfoDetail.popupImg1 = res.data.data.popupImg1;
        signUser.homeMainInfoDetail.popupImg2 = res.data.data.popupImg2;
        signUser.homeMainInfoDetail.popupImg3 = res.data.data.popupImg3;
        signUser.homeMainInfoDetail.popupImg4 = res.data.data.popupImg4;
        signUser.homeMainInfoDetail.popupImg5 = res.data.data.popupImg5;
        signUser.homeMainInfoDetail.button1Link = res.data.data.button1Link;
        signUser.homeMainInfoDetail.button1Name = res.data.data.button1Name;
        signUser.homeMainInfoDetail.button2Link = res.data.data.button2Link;
        signUser.homeMainInfoDetail.button2Name = res.data.data.button2Name;
        signUser.homeMainInfoDetail.button3Link = res.data.data.button3Link;
        signUser.homeMainInfoDetail.button3Name = res.data.data.button3Name;
        signUser.homeMainInfoDetail.button4Link = res.data.data.button4Link;
        signUser.homeMainInfoDetail.button4Name = res.data.data.button4Name;
      } else {
        // 사이트 데이터가 없으면(없는/잘못된 idx) 404 로 보낸다. 이미 /notFound 면 루프 방지로 스킵.
        if (route.path !== "/notFound") {
          router.replace("/notFound");
        }
      }
    });
  },
});

onMounted(async () => {
  const idxLeSiteMain = store.getters.getIdxLeSiteMain;

  if (idxLeSiteMain) {
    store.commit("setIdxLeSiteMain", idxLeSiteMain);
    signUser.homeMainInfoDetail.idxLeSiteMain = idxLeSiteMain;
    // idx 가 있을 때만 조회한다. 빈 idx 로 호출하면 백엔드가 500(값을 확인해주세요)을 주고 alert 이 뜬다.
    signUser.getSiteMain();
  }

  setViewport();
  await nextTick();

  window.addEventListener("resize", async () => {
    setViewport();

    await nextTick();
  });
});
</script>

<template>
  <ComHeader v-if="!route.meta.hideLayout && !hideHeader"></ComHeader>

  <div v-if="!route.meta.hideLayout" :class="hideHeader ? '' : [isNav ? 'pt-[115px]' : 'pt-[74px]', 'pc:pt-[93px]']">
    <router-view />
  </div>
  <router-view v-else />

  <ComFooter v-if="!route.meta.hideLayout"></ComFooter>
</template>
